import { Realm } from './i18nService';

export const initializeTheme = (realm: Realm) => {
  if (realm === 'bitiba') {
    document.body.classList.add('z-brand-theme-2024-bitiba');
  }
};
